import { gql } from '@apollo/client';
// import { CATEGORY_FILE_FIELDS } from '../Tender/queries';

const TENDER_FILE_ITEM_FIELDS = gql`
  fragment tenderFileItemFields on ProcurementFileItem {
    fileName
    dateUploaded
    targetPath
    fileType
  }
`;

export const CATEGORY_FILE_FIELDS = gql`
  fragment categoryFileFields on ProcurementFileCategory {
    name
    description
    files {
      ...tenderFileItemFields
    }
  }
  ${TENDER_FILE_ITEM_FIELDS}
`;

export const OCDS_PERIOD_FIELDS = gql`
  fragment OcdsPeriodFields on SimpleTender {
    startDate
    endDate
    durationInDays
  }
`;
export const OCDS_VALUE_FIELDS = gql`
  fragment OcdsValueFields on ValueObject {
    amount
    currency
  }
`;

export const GET_FREE_TENDER = gql`
  query getFreeTender {
    getSimpleTender {
      id
      date
      documents {
        name
        description
        files {
          fileName
          dateUploaded
          targetPath
          fileType
        }
      }
      tender {
        id
        title
        description
        procurementMethodDetails
        awardCriteriaDetails
        documentUrl
        submissionUrl
        questionsUrl
        techniques {
          hasFrameworkAgreement
        }
        renewal {
          description
        }
        contractPeriod {
          startDate
          endDate
          durationInDays
        }
        items {
          performanceNuts
          deliveryLocation {
            description
          }
        }
        maxValue {
          ...OcdsValueFields
        }
        minValue {
          ...OcdsValueFields
        }
        tenderPeriod {
          endDate
        }
        enquiryPeriod {
          endDate
        }
        value {
          ...OcdsValueFields
        }
      }
      parties {
        name
        identifier {
          id
        }
        address {
          locality
          streetAddress
          nuts
          postalCode
        }
        contactPoint {
          name
          telephone
          email
        }
        details {
          url
          buyerProfile
        }
      }
    }
  }
  ${OCDS_VALUE_FIELDS}
`;

export const GET_TENDER_FREE_FILE = gql`
  query getTenderFreeFile($filePath: String!) {
    getFile(filePath: $filePath) {
      url
    }
  }
`;
export const GET_TENDER_ID = gql`
  query getTenderID {
    getRedirectId {
      redirectId
    }
  }
`;
